import React from 'react';
import styled from 'styled-components';
import { Header } from '@app/navigation/header';
import { Body } from '@ui';
import { useNavigate } from 'react-router';
import { ROUTES } from '@constants/routes';
import { ScreenerTool } from '@containers/DigitalAnalyst/ScreenerTool';
import { scrollToTop } from '@utils/usefulFuncs';
import { AI_TOOLS } from '@constants';

const PageWrapper = styled.div`
  + div {
    width: 100%;
  }
`;

const tool = AI_TOOLS.RESEARCH_SCREENING;

function ResearchScreener() {
  const navigate = useNavigate();

  const onGoBack = () => navigate(ROUTES.home);

  React.useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <ScreenerTool onGoBack={onGoBack} isResearchMode tool={tool} />
      </Body>
    </PageWrapper>
  );
}

export default ResearchScreener;
